export default {
    install(vue){
        const hasMinutesPassed = (date, minutes) => Math.round((new Date() - date) / 60000) < minutes

        const checkCache = (key, cache) => {
            if (!cache) return false;
            return hasMinutesPassed(new Date(cache.modified), cache.length);
        };

        const Get = async (key = Math.random().toString(), length = 60, addDataFunction = () => {}) => {
            const cache = JSON.parse(localStorage.getItem(key));
            if (checkCache(key, cache)) return cache.data;

            const data = await addDataFunction();
            localStorage.setItem(key, JSON.stringify({
                modified: new Date(),
                length,
                data
            }));

            return data;
        }

        vue.prototype.$cache = {
            Get
        };
        vue.$cache = {
            Get
        };
    }
}